import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0094',
    ecrans: ['00-2'],
    params: ['el2cleint']
});
